import { Footer } from 'common/Components/Footer';
import { useTranslation } from 'react-i18next';
import ActivationStepFactory from './components/ActivationStepFactory';

const AccountActivationMobile = () => {
  //
  const { t } = useTranslation();

  return (
    <div className="bg-L-gray-50 dark:bg-D-gray-50 h-[100vh] max-h-[100vh] overflow-hidden inset-0 relative grid grid-rows-min-one">
      <div className="p-4">
        <ActivationStepFactory />
        <div className="mt-4 text-center"></div>
      </div>

      <div className="w-full h-auto bg-img-login bg-cover p-4 overflow-y-auto bg-center">
        <h5 className="text-2xl text-L-primary-50 ">
          {t(`Privacy.NoteTitle`)}:
        </h5>
        <Footer />
      </div>
    </div>
  );
};

export default AccountActivationMobile;
